import { IRatingFieldConfigurationClient, IRatingFieldConfigurationServer } from "./interface";

export const DEFAULT_RATING_VALUE = 1;
export const DEFAULT_UPPER_LIMIT = 5;
export const DEFAULT_PRECISION = 1;
export const ratingPrecisionOptions = {
  0.5: 0.5,
  1: 1,
};
export const defaultRatingFieldValueData = {
  rating: DEFAULT_RATING_VALUE,
  upperLimit: DEFAULT_UPPER_LIMIT,
  precision: DEFAULT_PRECISION,
};

// export const StartRatingOptions = {
//   0: "0",
//   1: "1",
// };

export const EndRatingsOptions = {
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  10: "10",
};

export const transformRatingConfigServerToClient = (
  fieldConfigServer: IRatingFieldConfigurationServer
): IRatingFieldConfigurationClient => {
  const { upperLimit, precision } = fieldConfigServer;
  const fieldConfigClient: IRatingFieldConfigurationClient = {
    upperLimit: parseInt(upperLimit?.selected),
    precision: parseFloat(precision?.selected),
  };
  return fieldConfigClient;
};


export const transformRatingFieldConfigClientToServer = (
  fieldConfigClient: IRatingFieldConfigurationClient
): IRatingFieldConfigurationServer => {
  const {
    upperLimit,
    precision,
  } = fieldConfigClient;
  const fieldConfigServer = {
    upperLimit: { selected: upperLimit.toString() },
    precision: { selected: precision.toString() },
  };
  return fieldConfigServer;
};
